import type { Province } from '@/core/models/address/province.model';
import type { District } from '@/core/models/address/district.model';
import type { Ward } from '@/core/models/address/ward.model';
import type { TollAreaModel } from '@/core/models/toll-area/toll-area.model';
import { AppUserAreaType } from '@/core/enums/global.enums';
import { selectWardOptions } from '@/core/utils/ward-options';
import { wardLabel } from './useProvinceWards';

export interface AreaTreeNode { value: string; label: string; children?: AreaTreeNode[]; }

/** Keep historical permission keys while exposing current wards without a district. */
export const buildAreaTree = (provinces: Province[], districts: District[], wards: Ward[], tollAreas: TollAreaModel[], preservedWardIds: readonly string[] = []): AreaTreeNode[] => {
    const visibleWards = selectWardOptions(wards, [...preservedWardIds, ...tollAreas.map(area => area.wardId)]);
    const wardNode = (ward: Ward): AreaTreeNode => ({
        label: wardLabel(ward),
        value: `${AppUserAreaType.Ward}_${ward.id}`,
        children: [
            { label: 'Tất cả Khu vực trực thuộc', value: `All_${AppUserAreaType.Ward}_${ward.id}` },
            ...tollAreas.filter(area => area.wardId === ward.id).map(area => ({
                label: area.name, value: `${AppUserAreaType.TollArea}_${area.id}`,
            })),
        ],
    });
    return provinces.map(province => ({
        label: province.name,
        value: `${AppUserAreaType.Province}_${province.id}`,
        children: [
            { label: 'Tất cả Xã/Khu vực trực thuộc', value: `All_${AppUserAreaType.Province}_${province.id}` },
            ...visibleWards.filter(ward => ward.provinceId === province.id && !ward.districtId).map(wardNode),
            ...districts.filter(district => district.provinceId === province.id).map(district => ({
                label: `${district.name} (cũ)`,
                value: `${AppUserAreaType.District}_${district.id}`,
                children: [
                    { label: 'Tất cả Xã trực thuộc', value: `All_${AppUserAreaType.District}_${district.id}` },
                    ...visibleWards.filter(ward => ward.districtId === district.id).map(wardNode),
                ],
            })),
        ],
    }));
};
